import React from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";

/**
 * FetchingErrorModal Component
 * 
 * Simple error message modal displayed when data fetching fails. Shows error icon,
 * generic error message, and link to contact support team. Typically rendered within
 * alert containers when API calls or data retrieval operations fail.
 * 
 * @returns {JSX.Element} Error message div with icon, description, and support link
 */
const FetchingErrorModal = () => {
  return (
    <div style={{ paddingTop: "10px" }}>
      <p style={{ color: "red" }}>
        <AiOutlineCloseCircle className="alert-icon" /> Error
      </p>
      <p style={{ marginLeft: "28px" }}>
        There seems to be an issue fetching the data.
        Please try again.
      </p>
      <p style={{ marginLeft: "28px" }}>
        If you still have trouble with fetching the data, please{" "}
        <a href="https://www.roiquant.com/contact">contact our support team</a>{" "}
        for help.
      </p>
    </div>
  );
};

export default FetchingErrorModal;
